// extracted by mini-css-extract-plugin
export default {"root":"MenuListModal_root__3qlhN"};